import { post, get, deletee } from '.';
import { AxiosPromise } from 'axios';

export type IGetDeletedItems = {
  type: 'SUBMODEL' | 'TRIM' | 'PART' | 'ALL';
  offset?: number;
  search?: string;
  limit?: number;
};

export const getAllDeletedItems = (
  params: IGetDeletedItems
): AxiosPromise<any> => {
  return get({
    subUrl: '/deleted-items',
    params: { ...params }
  });
};

export type IRestoreItems = {
  type: 'SUBMODEL' | 'TRIM' | 'PART';
  id: string;
};

export const restoreItems = (data: IRestoreItems): AxiosPromise<any> => {
  return post({
    subUrl: '/deleted-items',
    data: data
  });
};

export const deleteItemsForever = (data: IRestoreItems): AxiosPromise<any> => {
  return deletee({
    subUrl: '/deleted-items',
    params: { ...data }
  });
};
